import * as R from "ramda";
import Api from "../../../../Services/Api";
import M from "moment";
import React from "react";
import FlexView from "react-flexview";
import {fetchDataAsync, FormatRupiah} from "../../../../Services/Utils";

export const getData = (tab, data, user, branchCode, samsatId) => {
    console.log(data);
    switch (tab) {
        case "stnk": {
            const {
                processSamsatSTNKId = null,
                processSamsatId = "",
                kodeCabang = "",
                namaPenerima = "",
                noSTNK = "",
                tanggalPenerimaanSTNK = "",
                uriSTNK = "",
                base64FotoSTNK = "",
            } = data ?? {};

            return {
                processSamsatSTNKId: !R.isNil(processSamsatSTNKId) ? processSamsatSTNKId : "",
                processSamsatId: !R.isEmpty(processSamsatId) ? processSamsatId : samsatId,
                kodeCabang: !R.isEmpty(kodeCabang) ? kodeCabang : branchCode,
                namaPenerima: !R.isEmpty(namaPenerima) ? namaPenerima : user?.user?.name,
                noSTNK: noSTNK ?? "",
                tanggalPenerimaanSTNK: !R.isEmpty(tanggalPenerimaanSTNK) ? tanggalPenerimaanSTNK : M(new Date()).format("DD-MM-YYYY"),
                uriSTNK: uriSTNK ?? "",
                base64FotoSTNK: base64FotoSTNK ?? "",
            };
        }
        case "taxSheets": {
            const {
                processSamsatPajakId = null,
                processSamsatId = "",
                kodeCabang = "",
                namaPenerima = "",
                noPajak = "",
                pajakProgresifPrice = "",
                tglPenerimaanLembarPajak = "",
                tentativeFj,
                fjOtherCost,
                otherCost
            } = data ?? {};
            
            return {
                processSamsatPajakId: !R.isNil(processSamsatPajakId) ? processSamsatPajakId : "",
                processSamsatId: processSamsatId || samsatId,
                kodeCabang: kodeCabang ||  branchCode,
                namaPenerima: namaPenerima || user?.user?.name,
                noPajak: noPajak ?? "",
                pajakProgresifPrice: pajakProgresifPrice ?? "",
                tglPenerimaanLembarPajak: tglPenerimaanLembarPajak || M(new Date()).format("DD-MM-YYYY"),
                tentativeFj: !tentativeFj,
                fjOtherCost: fjOtherCost || 0,
                otherCost: otherCost || 0
            };
        }
        case "platNumber": {
            const {
                processSamsatPlatId = null,
                processSamsatId = "",
                namaPenerima = "",
                nomorPlat = "",
                kodeCabang = "",
                tglPenerimaanPlat = "",
                buktiFisikPlatUri = "",
                base64BuktiFisikPlat = "",
            } = data ?? {};

            return {
                processSamsatPlatId: !R.isNil(processSamsatPlatId) ? processSamsatPlatId : "",
                processSamsatId: !R.isEmpty(processSamsatId) ? processSamsatId : samsatId,
                kodeCabang: !R.isEmpty(kodeCabang) ? kodeCabang : branchCode,
                namaPenerima: !R.isEmpty(namaPenerima) ? namaPenerima : user?.user?.name,
                nomorPlat: nomorPlat ?? "",
                tglPenerimaanPlat: !R.isEmpty(tglPenerimaanPlat) ? tglPenerimaanPlat : M(new Date()).format("DD-MM-YYYY"),
                buktiFisikPlatUri: buktiFisikPlatUri ?? "",
                base64BuktiFisikPlat: base64BuktiFisikPlat ?? "",
            };
        }
        case "bpkb": {
            const {
                processSamsatBPKBId = null,
                processSamsatId = "",
                kodeCabang = "",
                namaPenerima = "",
                nomorBPKB = "",
                tglPenerimaanBPKB = "",
                buktiBPKBUri = "",
                base64BuktiBPKB = "",
            } = data ?? {};
            console.log(processSamsatBPKBId, !R.isEmpty(processSamsatId));

            const bpkb = {
                processSamsatBPKBId: !R.isNil(processSamsatBPKBId) ? processSamsatBPKBId : "",
                processSamsatId: !R.isEmpty(processSamsatId) ? processSamsatId : samsatId,
                kodeCabang: !R.isEmpty(kodeCabang) ? kodeCabang : branchCode,
                namaPenerima: !R.isEmpty(namaPenerima) ? namaPenerima : user?.user?.name,
                nomorBPKB: nomorBPKB ?? "",
                tglPenerimaanBPKB: !R.isEmpty(tglPenerimaanBPKB) ? tglPenerimaanBPKB : M(new Date()).format("DD-MM-YYYY"),
                buktiBPKBUri: buktiBPKBUri ?? "",
                base64BuktiBPKB: base64BuktiBPKB ?? "",
            };

            console.log("bpkb", bpkb);

            return bpkb;
        }
        default: {
            return {};
        }
    }
}

export const saveReceivingSamsat = async (tab, payload, setError) => {
    switch (tab) {
        case "stnk": {
            return await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").saveReceivingSamsatSTNK,
                menuName: "Proses Samsat - Penerimaan Samsat",
                setError,
                args: payload,
            });
        }
        case "taxSheets": {
            return await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").saveReceivingSamsatLembarPajak,
                menuName: "Proses Samsat - Penerimaan Samsat",
                setError,
                args: payload,
            });
        }
        case "platNumber": {
            return await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").saveReceivingSamsatPlatKendaraan,
                menuName: "Proses Samsat - Penerimaan Samsat",
                setError,
                args: payload,
            });
        }
        case "bpkb": {
            return await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").saveReceivingSamsatBPKB,
                menuName: "Proses Samsat - Penerimaan Samsat",
                setError,
                args: payload,
            });
        }
        default: {
            return {};
        }
    }
}

export const generateSaveAlertContent = (tab, dataDetail, controls) => {
    return (
        <FlexView column style={{justifyContent: "center"}} hAlignContent={"left"}>
            <span>Proses Penerimaan STNK SAMSAT dengan</span>
            <br/>
            <span>Nomor Faktur Jual: {dataDetail.salesFakturNo}</span>
            <span>Nomor Rangka: {dataDetail.frameNumber}</span>
            <span>Nomor Mesin: {dataDetail.engineNumber}</span>
            {
                R.equals(tab, "stnk")
                    ? <span>Nomor STNK: {controls.noSTNK?.value}</span>
                    : R.equals(tab, "taxSheets") ?
                        <>
                            <span>Nomor Pajak: {controls.noPajak?.value}</span>
                            <span>Pajak Progresif: {FormatRupiah({number: controls.pajakProgresifPrice?.value})}</span>
                        </>
                        : R.equals(tab, "platNumber") ? <span>Nomor Plat Kendaraan: {controls.nomorPlat?.value}</span>
                            : R.equals(tab, "bpkb") ? <span>Nomor BPKB: {controls.nomorBPKB?.value}</span> : null

            }
            <br/>
            <span>akan DISIMPAN, apakah anda yakin?</span>
        </FlexView>
    )
}